import { get, post, patch, del } from './api';
import type { WeaponTemplateResponse } from './games';

export type PlayedWeapon = {
  id: number;
  name: string;
  description: string;
  game_code: string;
  already_templated: boolean;
};

function withPassword(password: string, body?: Record<string, unknown>) {
  return { ...body, admin_password: password };
}

export function adminFetchTemplates(password: string) {
  return get<WeaponTemplateResponse[]>(
    `/admin/templates/?admin_password=${encodeURIComponent(password)}`
  );
}

export function adminCreateTemplate(
  password: string,
  data: {
    name: string;
    description: string;
    difficulty: string;
    location: string;
    language: string;
  }
) {
  return post<WeaponTemplateResponse>('/admin/templates/', withPassword(password, data));
}

export function adminUpdateTemplate(
  password: string,
  id: number,
  data: Partial<{
    name: string;
    description: string;
    difficulty: string;
    location: string;
    language: string;
  }>
) {
  return patch<WeaponTemplateResponse>(`/admin/templates/${id}/`, withPassword(password, data));
}

export function adminDeleteTemplate(password: string, id: number) {
  return del<void>(`/admin/templates/${id}/`, withPassword(password));
}

export function adminFetchPlayedWeapons(password: string) {
  return get<PlayedWeapon[]>(
    `/admin/played-weapons/?admin_password=${encodeURIComponent(password)}`
  );
}

export function adminPromoteWeapon(
  password: string,
  weaponId: number,
  meta: { difficulty: string; location: string; language: string }
) {
  return post<WeaponTemplateResponse>(
    '/admin/templates/promote/',
    withPassword(password, { weapon_id: weaponId, ...meta })
  );
}
